export type BeerLike = {
  description?: string | null;
};

export type PortfolioCompleteness = {
  totalBeers: number;
  beersWithDescription: number;
  descriptionPercent: number;
  missingDescriptionCount: number;
};

export function beerHasDescription(beer: BeerLike): boolean {
  const description = beer.description;
  return typeof description === 'string' && description.trim().length > 0;
}

export function computePortfolioCompleteness(beers: BeerLike[]): PortfolioCompleteness {
  if (!Array.isArray(beers) || beers.length === 0) {
    return {
      totalBeers: 0,
      beersWithDescription: 0,
      descriptionPercent: 0,
      missingDescriptionCount: 0,
    };
  }

  const beersWithDescription = beers.filter((beer) => beerHasDescription(beer)).length;
  const totalBeers = beers.length;
  const descriptionPercent = Math.round((beersWithDescription / totalBeers) * 100);
  const missingDescriptionCount = totalBeers - beersWithDescription;

  return {
    totalBeers,
    beersWithDescription,
    descriptionPercent,
    missingDescriptionCount,
  };
}
